import Mock from './mock'

import './db/auth'
import './db/invoice'
import './db/calendarEvents'
import './db/users'
import './db/inbox'
import './db/chat'
import './db/todos'
import './db/list'
import './db/scrumBoard'
import './db/notification'
import './db/ecommerce'
import './db/OrderListFastFood/OrderList'
import './db/Reference/ChangeList'
import './db/Reference/referenceColor'
import './db/Reference/referenceNotes'
import './db/Reference/referenceOrderSource'
import './db/Reference/referenceWriteOff'
import './db/Reference/referenceStatusOrder'
import './db/Reference/referenceTypePayments'
import './db/Reference/referenceMarks'
import './db/Reference/referenceSuppliers'
import './db/Reference/referenceUnits'
import './db/Reference/referenceStreet'
import './db/Reference/referenceMarkup'
import './db/Reference/referencePositionWorker'
import './db/Reference/referenceDiscount'
import './db/Reference/referenceKlientDirectory'
import './db/Reference/referenceOrganization'
import './db/Reference/referenceEmployeesList'
import './db/Reference/referenceCertificate'
import './db/Reference/referencePromocode'
import './db/Settings/AffiliateList'
import './db/Settings/Outlets'
import './db/Settings/UserList'
import './db/Catalog/Category'
import './db/Catalog/ProductTags'
import './db/Catalog/ProductList'
import './db/UpdateSortable/UpdateSortable'
import './db/marketing/Gifts'
import './db/marketing/PromoCreate'
import './db/profile'
import './db/map'
import './db/telephony'
import './db/bonus'
import './db/cashbox'
import './db/fiscal'
import './db/frontpadSync'
import './db/brand'
import './db/siteCatalogSync'
import './db/superadmin'
import './db/billing'
import './db/dataExport'
import './db/warehouse'
import './db/knowledge'


Mock.onAny().passThrough()
